module.exports = __webpack_public_path__ + "img/69.086fbcaf.png";